var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{class:[{ main: _vm.layout === 'white' }]},[_c('Navbar'),_c('router-view')],1),_c('div',{staticClass:"text-center",staticStyle:{"background-color":"black"}},[_c('v-overlay',{attrs:{"absolute":true,"opacity":0.8,"value":_vm.isLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }